import { render } from "./PhoneNumberField.vue?vue&type=template&id=8c5d7630"
import script from "./PhoneNumberField.vue?vue&type=script&lang=js"
export * from "./PhoneNumberField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PhoneNumberField.vue"]])

export default __exports__